// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"a3cbf5a9","60":"d3ffab17","228":"130efdde","307":"537f110f","950":"537f110f"}[chunkId] + ".chunk.css";
};